import React from 'react';
import Editor from './editor';

class EditSchoolModal extends React.Component {
	render() {
		return (
			<div className="lit-modal" onClick={() => this.props.onCancel()}>
				<div
					className="lit-modal__other"
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<div>
						<Editor
							onEditModelConfirm={this.props.onConfirm}
							onEditModelCancel={this.props.onCancel}
							selectedSchool={this.props.selectedSchool}
							refreshSchools={this.props.refreshSchools}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default EditSchoolModal;
